import { render, staticRenderFns } from "./YearTabs.vue?vue&type=template&id=3cabe922&scoped=true&"
import script from "./YearTabs.vue?vue&type=script&lang=js&"
export * from "./YearTabs.vue?vue&type=script&lang=js&"
import style0 from "./YearTabs.vue?vue&type=style&index=0&id=3cabe922&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cabe922",
  null
  
)

export default component.exports